import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import i18n from 'utils/I18n';
import { getInboxUnreadCount, loginCommonNavItemList, unloginCommonNavItemList } from 'component/common/navigator/NavigatorUtils';
import { showMenuButtonInNavigatorBar } from 'utils/UIConfigUtils'
import HoverDropDown from 'component/common/navigator/HoverDropDown';
import { NavType } from 'utils/CustomEnums';

const NavItem = ({ item, index, inboxUnreadCount }) => {
  if (item.navType == NavType.DROP_DOWN) {
    return (
      <Nav.Item key={item.name}>
        <HoverDropDown menuList={item.navDropList} title={i18n.t(item.name)} />
      </Nav.Item>
    )
  }
  return (
    <Nav.Item key={item.name}>
      <LinkContainer to={item.linkTo}>
        <div className="nav_div">
          {i18n.t(item.name)} {item.showUnreadCount && inboxUnreadCount}
        </div>
      </LinkContainer>
    </Nav.Item>
  )
}

const CenterComponent = ({
  language,
  isLogin,
  messageUnreadCount,
  navBarConfig,
  isMobile,
  isInMiniProgram,
}) => {
  const inboxUnreadCount = useMemo(() => (
    getInboxUnreadCount(messageUnreadCount)
  ), [messageUnreadCount])

  if (isMobile || isInMiniProgram) {
    return null;
  }

  if (!navBarConfig.webShowSections) {
    return null;
  }

  const showMenuButton = showMenuButtonInNavigatorBar()
  if (!showMenuButton) {
    return null
  }
  const finalNavList = isLogin ? loginCommonNavItemList : unloginCommonNavItemList

  return (
    <Nav className="header-center-container">
      {
        finalNavList.map(item => (
          <NavItem item={item} inboxUnreadCount={inboxUnreadCount} />
        ))
      }
    </Nav>
  );
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  messageUnreadCount: state.inboxMessages.unReadCount,
});

export default connect(mapStateToProps)(CenterComponent);
